<template>
  <div>
    <ComponentCollapse
      class="collect_list"
      :activeNamesList="recordLists"
      @change="change"
    >
      <ul
        slot="collapseContent"
        class="collapse-cell"
        v-for="item in numList"
        :key="item.question_style"
      >
        <li class="item">{{ item.style_name.slice(0, -2) }}</li>
        <li class="item">{{ item.num }}</li>
        <li class="item">
          <el-button class="uni-link-btn" type="primary" @click="jump(item)"
            >查看</el-button
          >
        </li>
      </ul>
    </ComponentCollapse>

    <ComponentEmpty
      v-if="recordLists.length == 0"
      title="暂无收藏记录"
      tips=""
    />
  </div>
</template>

<script>
import { getCollectRecords, getCollectNum } from "@/api/basic";
import ComponentCollapse from "@/components/componentCollapseTo";
export default {
  name: "problem",
  components: {
    ComponentCollapse,
  },
  data() {
    return {
      recordLists: [],
      numList: [],
      course_id: "",
    };
  },
  created() {
    this.getCollectRecords();
  },
  methods: {
    // 课程
    async getCollectRecords() {
      const res = await getCollectRecords();
      if (res.code == 200) {
        this.recordLists = res.result;

        // if (this.recordLists.length > 0) {
        //   let course_id = this.recordLists[0].id;
        //   this.getNum(course_id);
        // }
      }
    },
    // 题型
    async getNum(course_id) {
      const res = await getCollectNum({
        course_id: course_id,
      });
      if (res.code == 200) {
        this.numList = res.result.list;
      }
    },
    change(val) {
      if (val) {
        this.course_id = val;
        this.getNum(val);
      }
    },
    jump(item) {
      this.$router.push({
        name: "myCollectDetail",
        query: {
          courseUuid: this.course_id,
          topicType: item.question_style,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.collect_list {
  /deep/ .header {
    background-color: #f8f9fb;
  }
}
.collapse-cell {
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 70px;

  .iconfont {
    vertical-align: middle;
    font-size: 20px;
    margin-right: 10px;
  }

  .item {
    flex: 1;
    text-align: center;
    &:nth-child(1) {
      text-align: left;
      flex: 2;
    }
  }

  .uni-link-btn {
    @include uni-link-btn(90px);
    margin-left: 40px;
  }
}
</style>
